import { z } from "zod";

// Schemas

export const MotionCategorySchema = z.enum([
  "subsidiary",
  "incidental",
  "recital",
  "privileged",
]);

export const MotionVotingTypeSchema = z
  .enum(["majority", "twothirds"])
  .or(z.literal(false));

export const MotionTypeSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: MotionCategorySchema,
  description: z.string(),
  interrupt: z.boolean(),
  second: z.boolean(),
  debate: z.boolean(),
  comment: z.string().or(z.literal(false)),
  amend: z.boolean(),
  nestable: z.boolean(),
  defers: z.boolean(),
  deferredReason: z.string().optional(),
  voting: MotionVotingTypeSchema,
  nicknames: z.string().array().optional(),
  adjourn: z.boolean().optional(),
  createAgendaItem: z.boolean().optional(),
});

export const MotionTypeMapSchema = z.object({
  item: z.record(MotionTypeSchema),
  meeting: z.record(MotionTypeSchema),
});
